
import { Injectable } from '@angular/core';
import { CotacaoRamoService } from './cotacao-ramo.service';
import { UtilsService } from '../utils.service';
import { IntegracaoConstants } from 'src/app/constants/integracao';
import { CalcsResults } from 'src/app/models/calculos/calcs-results.model';
import { CalcBike } from 'src/app/models/calcBike.model';
import { ApiApiceService } from '../api/api-apice.service';
import { LeadsConstants } from 'src/app/constants/leads';

@Injectable({
  providedIn: 'root'
})

export class CotacaoBikeService implements CotacaoRamoService {

  public _leadsCadastrados = LeadsConstants.leads;
  public _seguradorasBase = IntegracaoConstants.seguradoras;
  private _sexo = IntegracaoConstants.sexoTxt;
  private _estadoCivil = IntegracaoConstants.estadoCivilTxt;
  private _stepsId = IntegracaoConstants.stepsId;
  private _ramos = IntegracaoConstants.ramos;
  private _packageType = IntegracaoConstants.packageType;

  private tipoReq = 5;
  public dadosUser: any = []
  private optionsBike = null;

  constructor(private utilsService: UtilsService, private api: ApiApiceService) { }

  async setDadosUser() {
    try {
      this.optionsBike = await this.api.getOptionsBike();
    } catch (err) {
      console.log(err)
    }
  }

  sessoesPDF() {
    return [{
      code: 1,
      description: "Segurado",
      selected: true
    },
    {
      code: 2,
      description: "Caracteristícas",
      selected: true
    },
    {
      code: 3,
      description: "Coberturas",
      selected: true
    },
    {
      code: 4,
      description: "Cálculos com erro",
      selected: true
    }]
  }

  setComissaoDefault(su) {
    su.percComissao = su.percComissaoBike ? su.percComissaoBike : 0;
    su.percDesconto = su.percDescontoBike ? su.percDescontoBike : 0;
    return su;
  }

  setCoberturas(v, obj) {
    return null;
  }

  getMessageCalcExtension(subramo?) {
    return 'VER_CALCULO_BIKE';
  }

  getColumnsGridCalculosVersao() {
    return [
      'seguradora',
      'premio',
      'comissao',
      'roubo',
      'danos',
      'responsabilidadeCivil',
      'assist24h',
      'tempo'
    ];
  }

  getCalcObject(draft, seguradoras, coberturas) {
    let obj = JSON.parse(JSON.stringify(draft));
    
    obj.ramo = this._ramos.BIKE;
    obj.tipo = 5;

    let hoje = new Date();
    let vigIni = new Date(obj.vigenciaIni);
    let limiteRetroativo: any = new Date();
    limiteRetroativo = this.utilsService.editarData({ data: limiteRetroativo, operacao: "-", dia: 15, mes: 0, ano: 0 });

    if (limiteRetroativo)
      if (limiteRetroativo.getTime() > vigIni.getTime()) {
        obj.vigenciaIni = hoje.toISOString();
      }

    for (let prop in obj) {
      if (obj === null)
        delete obj[prop];
    }

    obj.calculos = seguradoras.habilitadas.filter(function (cfg) { return cfg.ativo });
    obj.calculos = obj.calculos.map(function (el) {
      let objCalc = { ...el, ...this.coberturasCalc };
      objCalc.percComissao = el.percCom ? parseInt(el.percCom) : 0;
      objCalc.percDesconto = el.percDesc ? parseInt(el.percDesc) : 0;

      this.utilsService.clearCfgSegToCalc(objCalc);

      if (!objCalc.libertyCodigoEstabelecimento)
        objCalc.libertyCodigoEstabelecimento = null;
      if (!objCalc.libertyDescontoRegional)
        objCalc.libertyDescontoRegional = 1;

      delete objCalc.ID;

      return objCalc;

    }.bind(this));

    return obj;

  }

  coberturasMerge(coberturas, obj) {
    return coberturas;
  }

  getSeguradorasStatus(seguradorasUser, servicesInfos, ramo) {
    let segStatus = servicesInfos.calculos.bike;

    for (let idx in segStatus) {

      let options = segStatus[idx];

      let reduced = options.reduce((filtered, option) => {
        if (seguradorasUser) {
          let seg = seguradorasUser.find((cfgUser) => { return option.id == cfgUser.seguradora });

          if (seg && seg.seguradora != this._seguradorasBase.AZUL.id && seg.seguradora != this._seguradorasBase.ALIRO.id) {

            seg.idIntegracaoCfg = seg.ID;
            seg.idIntegracaoCfgSeg = seg.ID;
  
            seg.login = seg.usuario;
  
            seg.percCom = seg.percComissao;
            seg.percDesc = seg.percDesconto;
  
            let cfgSegConfig = { ...option, ...seg };
  
            filtered.push(cfgSegConfig);
  
          }
        }

        return filtered;
      }, []);

      segStatus[idx] = reduced;
      segStatus[idx].sort(function (a, b) {
        if (a.nome > b.nome) {
          return 1;
        }
        if (a.nome < b.nome) {
          return -1;
        }
        return 0;
      });

    }

    return segStatus;
  }

  async getCoberturasUser(api) {
    return null;
  }

  matStepRoute(action, selectedStep, flags) {
    switch (selectedStep) {
      case this._stepsId.formulario:
        if (action == "next") {
          return "enviarCalculo";
        } else if (action == "previous") {
          return "resultados";
        }
        break;
      case this._stepsId.simuladorComissoes:
        if (action == "next") {
          return "simuladorComissoes";
        } else if (action == "previous") {
          return "resultados";
        }
        break;
      case this._stepsId.enviarCalculo:
        if (action == "next") {
          return "calcular";
        } else if (action == "previous") {
          if (flags.simuladorComissoes) {
            return "simuladorComissoes";
          } else if (flags.calcular) {
            return "resultados";
          } else {
            return "formulario"
          }
        }
        break;
    }
  }

  //adaptado para o apice
  createDraft(negocio, opt?) {
    if (!negocio)
      negocio = new CalcBike();
    negocio.tipo = this.tipoReq;
    if (opt) {
      if (opt.seguradoUrl) {
        let propertiesToCopy = [
          "nome",
          "cpfCnpj",
          "estadoCivil",
          "dataNasc",
          "sexo",
          "fone1",
          "fone",
          "email",
          "cep"
        ];
        propertiesToCopy.forEach((p) => {
          negocio.segurado[p] = opt.seguradoUrl[p];
        });
        negocio.segurado.seguradoUrl = true;
      }
      if (opt.negocioUrl) {
        negocio.negocioId = opt.negocioUrl;
      }
    }
    return negocio;
  }

  createVersions(arrayVersions) {
    return arrayVersions.map((v) => {

      //Se não tiver versão, é calculo antigo, e respectivamente é a primeira versão, ou
      //Versão é igual a 0 e foi somente salvo, sem calcular, não deveria acessar a tela de resultado, somente o formulario.
      if (!v.versao && v.versao !== 0)
        v.versao = 1;

      this.addVersion(v);

      this.utilsService.setResultsAll(v);
      this.utilsService.sortResults(v);

      return v;

    });
  }

  private addVersion(v) {
    v.vigenciaIniTxt = this.utilsService.dateStringToTxt(v.vigenciaIni);
    v.vigenciaFimTxt = this.utilsService.dateStringToTxt(v.vigenciaFim);
    v.segurado.cpfCnpjTxt = this.utilsService.cpfCnpj(v.segurado.cpfCnpj);
    v.segurado.dataNascTxt = this.utilsService.dateStringToTxt(v.segurado.dataNasc);
    v.segurado.sexoTxt = this._sexo[v.segurado.sexo];
    v.segurado.cepTxt = this.utilsService.formatCep(v.segurado.cep);

    v.results = new CalcsResults();

    this.updateResults(v);

  }

  public updateResults(v) {
    v.calculos.map((vr) => {
      this.extractResultsBike(v, vr);
    });

    this.utilsService.setResultsAll(v);
    this.utilsService.sortResults(v);
  }

  private extractResultsBike(v, calc) {

    delete calc['corretora'];

    let id = 0;

    v.configuracoes.dataAquisicaoTxt =  this.utilsService.dateStringToTxt(v.configuracoes?.dataAquisicao);
    v.configuracoes.marcaTxt = v.configuracoes?.marca ? this.getOption('Marca', v.configuracoes?.marca) : "--";
    v.configuracoes.tipoTxt = v.configuracoes?.tipo ? this.getOption('Tipo', v.configuracoes?.tipo) : "--";
    v.configuracoes.estadoConservacaoTxt = v.configuracoes?.estadoConservacao ? this.getOption('Estado', v.configuracoes?.estadoConservacao) : "--";
    v.configuracoes.materialTxt = v.configuracoes?.material ? this.getOption('Material', v.configuracoes?.material) : "--";
    v.configuracoes.configuracaoTxt = v.configuracoes?.configuracao ? this.getOption('Configuracao', v.configuracoes?.configuracao) : "--";
    v.configuracoes.frequenciaUsoTxt = v.configuracoes?.frequenciaUso ? this.getOption('Frequencia', v.configuracoes?.frequenciaUso) : "--";
    v.configuracoes.assessoriaEsportivaTxt = v.configuracoes?.assessoriaEsportiva ? this.getOption('Assessoria', v.configuracoes?.assessoriaEsportiva) : "Não";
    v.configuracoes.assist24hsTxt = v.configuracoes?.assist24hs ? this.getOption('Assistencia', v.configuracoes?.assist24hs) : 'Não';
    v.configuracoes.usoTxt = v.configuracoes?.uso ? this.getOptionArray('Uso', v.configuracoes?.uso) : "--";
    v.configuracoes.modalidadeTxt = v.configuracoes?.modalidade ? this.getOptionArray('Modalidade', v.configuracoes?.modalidade) : "--";
    v.configuracoes.terrenoTxt = v.configuracoes?.terreno ? this.getOptionArray('Terreno', v.configuracoes?.terreno) : "--";
    v.configuracoes.valorMercadoTxtRS = v.configuracoes.valorMercado ? this.utilsService.numberFormat(v.configuracoes.valorMercado, true) : "--";
    v.configuracoes.anoFabricacaoTxt = v.configuracoes.anoFabricacao ? String(v.configuracoes.anoFabricacao) : "--";
    v.configuracoes.notaFiscalTxt = v.configuracoes?.notaFiscal ? this.getOption('NotaFiscal', v.configuracoes?.notaFiscal) : "Não";
    v.configuracoes.isDanosTxtRS = v.configuracoes.isDanos ? this.utilsService.numberFormat(v.configuracoes.isDanos, true) : "--";
    v.configuracoes.isDanosRouboTxtRS = v.configuracoes.isRoubo ? this.utilsService.numberFormat(v.configuracoes.isRoubo, true) : "--";
    v.configuracoes.responsabilidadeCivilTxtRS = v.configuracoes.responsabilidadeCivil ? this.utilsService.numberFormat(v.configuracoes.responsabilidadeCivil, true) : "--";
    v.configuracoes.isDanosEletricosTxtRS = v.configuracoes.isDanosEletricos ? this.utilsService.numberFormat(v.configuracoes.isDanosEletricos, true) : "--";
    v.configuracoes.isApIndividualTxtRS = v.configuracoes.isApIndividual ? this.utilsService.numberFormat(v.configuracoes.isApIndividual, true) : "--";

    let iterarCalcs = calc.resultados;

    if (!Array.isArray(iterarCalcs) || iterarCalcs.length == 0) {
      let copyToResult = JSON.parse(JSON.stringify(calc));
      copyToResult.principal = true;
      iterarCalcs = [copyToResult];
    }

    if (iterarCalcs) {

      iterarCalcs.map(function (vrr) {
        id = id + 1;
        vrr.ramo = this.ramo;
        vrr.retorno = calc.retorno;
        vrr.idPacote = calc.seguradora + "-" + id;
        vrr.nome = this.utilsService.getSegNameById(calc.seguradora);
        vrr.logo = this.utilsService.getPathLogoById(calc.seguradora);
        vrr.tempoResposta = calc.tempoResposta ? calc.tempoResposta / 1000 : "";
        vrr.isError = calc.erros ? calc.erros.length > 0 : false;
        vrr.seguradora = calc.seguradora;

        if (vrr.principal && !vrr.identificacao) {
          vrr.identificacao = "Principal";
        } else if (!vrr.principal && !vrr.identificacao) {
          vrr.identificacao = "Alternativo";
        }

        vrr.identificacaoLim = vrr.identificacao;

        if (vrr.identificacaoLim.length >= 24) {
          vrr.identificacaoLim = vrr.identificacaoLim.replace(/(.{0,22}).*/, "$1...")
        }

        vrr.idIntegracaoCfgSeg = calc.idIntegracaoCfgSeg;
        if (vrr.hasOwnProperty('idCalculo'))
          vrr.nroCalculo = vrr.idCalculo;

        vrr.premioTxt = vrr.premio ? this.utilsService.numberFormat(parseFloat(vrr.premio)) : "--";
        vrr.premioTxtRS = vrr.premio ? this.utilsService.numberFormat(parseFloat(vrr.premio), true) : "--";

        if (vrr.coberturas) {
          vrr.coberturas.percDescontoTxt = vrr.coberturas.percDesconto ? (vrr.coberturas.percDesconto + "%") : "--";
          vrr.coberturas.percDesconto = vrr.coberturas.percDesconto ? vrr.coberturas.percDesconto : "--";
          vrr.coberturas.percComissaoTxt = vrr.coberturas.percComissao ? (vrr.coberturas.percComissao + "%") : "--";

          vrr.coberturas.isDanosTxt = vrr.coberturas.isDanos ? this.utilsService.numberFormat(vrr.coberturas.isDanos) : "--";
          vrr.coberturas.isDanosTxtRS = vrr.coberturas.isDanos ? this.utilsService.numberFormat(vrr.coberturas.isDanos, true) : "--";

          vrr.coberturas.isDanosRouboTxt = vrr.coberturas.isRoubo ? this.utilsService.numberFormat(vrr.coberturas.isRoubo) : "--";
          vrr.coberturas.isDanosRouboTxtRS = vrr.coberturas.isRoubo ? this.utilsService.numberFormat(vrr.coberturas.isRoubo, true) : "--";

          vrr.coberturas.responsabilidadeCivilTxt = vrr.coberturas.responsabilidadeCivil ? this.utilsService.numberFormat(vrr.coberturas.responsabilidadeCivil) : "--";
          vrr.coberturas.responsabilidadeCivilTxtRS = vrr.coberturas.responsabilidadeCivil ? this.utilsService.numberFormat(vrr.coberturas.responsabilidadeCivil, true) : "--";

          vrr.coberturas.isDanosEletricosTxt = vrr.coberturas.isDanosEletricos ? this.utilsService.numberFormat(vrr.coberturas.isDanosEletricos) : "--";
          vrr.coberturas.isDanosEletricosTxtRS = vrr.coberturas.isDanosEletricos ? this.utilsService.numberFormat(vrr.coberturas.isDanosEletricos, true) : "--";

          vrr.coberturas.isApIndividualTxt = vrr.coberturas.isApIndividual ? this.utilsService.numberFormat(vrr.coberturas.isApIndividual) : "--";
          vrr.coberturas.isApIndividualTxtRS = vrr.coberturas.isApIndividual ? this.utilsService.numberFormat(vrr.coberturas.isApIndividual, true) : "--";

          vrr.coberturas.assist24hsTxt = vrr.coberturas.assist24hs ? vrr.coberturas.assist24hs : '--';
          vrr.coberturas.assistxtMod = vrr.coberturas.assist24hs;

        } else {
          vrr.coberturas = {};
        }
        
        if (!vrr.hasOwnProperty('franquias')) vrr.franquias = {};
        vrr.franquias.isDanosTxt = vrr.franquias.isDanos ? vrr.franquias.isDanos : "--";
        vrr.franquias.isDanosRouboTxt = vrr.franquias.isRoubo ? vrr.franquias.isRoubo : "--";
        vrr.franquias.responsabilidadeCivilTxt = vrr.franquias.responsabilidadeCivil ? vrr.franquias.responsabilidadeCivil : "--";
        vrr.franquias.isDanosEletricosTxt = vrr.franquias.isDanosEletricos ? vrr.franquias.isDanosEletricos : "--";
        vrr.franquias.isApIndividualTxt = vrr.franquias.isApIndividual ? vrr.franquias.isApIndividual : "--";

        vrr.msErros = calc.erros;
        vrr.msAlertas = calc.alertas;

        if (vrr.alertas)
          vrr.msAlertas = Array.isArray(vrr.msAlertas) ? vrr.msAlertas.concat(vrr.alertas) : vrr.alertas;

        let verificarPremio = vrr.premio && vrr.premio > 0;

        if (vrr.retorno && !vrr.isError && !verificarPremio) {
          vrr.isError = true;
          vrr.msErros = ["Houve um erro não identificado ao realizar este cálculo."];
        }

        let arrToAdd = vrr.isError ? "errors" : "successes";
        if (vrr.hasOwnProperty('packageType') && Object.values(this._packageType).includes(vrr.packageType)) {
          if (vrr.packageType === this._packageType.PRINCIPAL) {
            vrr.isAlternative = !vrr?.selected;
            v.results[vrr?.selected ? 'main' : 'alternatives'][arrToAdd].push(vrr);
          } else if (vrr.packageType === this._packageType.MENSAL) {
            vrr.isPorAssinatura = true;
            v.results.porAssinatura[arrToAdd].push(vrr);
          } else {
            vrr.isAlternative = true;
            v.results.alternatives[arrToAdd].push(vrr);
          }
        } else {
          let isPorAssinatura = this.utilsService.isCalcPorAssinatura(calc.seguradora);

          if (isPorAssinatura) {
            vrr.isPorAssinatura = true;
            v.results.porAssinatura[arrToAdd].push(vrr);
          } else {
            let isAlternative = this.utilsService.isCalcAutoAlternative(calc.seguradora);
  
            if (vrr.principal && !isAlternative) {
              vrr.isAlternative = false;
              v.results.main[arrToAdd].push(vrr);
            } else if ((!vrr.isError) || isAlternative) {
              vrr.isAlternative = true;
              v.results.alternatives[arrToAdd].push(vrr);
            }
          }
        }
      }.bind(this));

    }
  }

  getOption(optionName, value) {
    let op = this.optionsBike?.[optionName]
    if (op) {
      let ditCob = op.find(d => {
        return d.Key === value
      })
  
      return ditCob?.Value ? ditCob?.Value : ''
    }
    return '';
  }

  getOptionArray(optionName, value: string[]): string {
    const resultado = value
      .map(valor => this.getOption(optionName, valor))
      .filter(Value => Value !== '');

    if (resultado.length > 1) {
      const ultimo = resultado.pop();
      return `${resultado.join(', ')} e ${ultimo}`;
    } else {
      return resultado.join(', ');
    }
  }

}
